import { render, staticRenderFns } from "./ContactPersonAvatar.vue?vue&type=template&id=37506c8d&scoped=true&"
import script from "./ContactPersonAvatar.vue?vue&type=script&lang=js&"
export * from "./ContactPersonAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ContactPersonAvatar.vue?vue&type=style&index=0&id=37506c8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37506c8d",
  null
  
)

export default component.exports